import { Link } from "react-router-dom";
import { fileUrl, money } from "@/lib/api";
import { Swatch } from "@/lib/colors";

export default function ProductCard({ product, index = 0 }) {
  const cover = product.cover_photo || product.photos?.[0];
  const second = product.photos?.find((p) => p !== cover);
  const soldOut = product.total_stock <= 0;
  return (
    <Link
      to={`/product/${product.slug}`}
      data-testid={`product-card-${product.slug}`}
      className="group block fade-up"
      style={{ animationDelay: `${Math.min(index, 8) * 70}ms` }}
    >
      <div className="relative aspect-[4/5] bg-[#0f0f12] overflow-hidden">
        {cover && (
          <img src={fileUrl(cover)} alt={product.name} loading="lazy"
            className={`absolute inset-0 w-full h-full object-cover transition-[transform,opacity] duration-700 ease-out group-hover:scale-[1.04] ${second ? "group-hover:opacity-0" : ""}`} />
        )}
        {second && (
          <img src={fileUrl(second)} alt="" loading="lazy" className="absolute inset-0 w-full h-full object-cover opacity-0 transition-opacity duration-700 group-hover:opacity-100" />
        )}
        {soldOut && (
          <span data-testid={`product-card-soldout-${product.slug}`} className="absolute top-3 left-3 bg-black/80 backdrop-blur text-white text-[10px] tracking-[0.2em] uppercase px-3 py-1.5 border border-white/10">
            Sold out
          </span>
        )}
      </div>
      <div className="pt-4 flex items-start justify-between gap-3">
        <div className="min-w-0">
          <h3 className="text-sm font-medium text-white truncate">{product.name}</h3>
          <div className="flex gap-1.5 mt-2">
            {product.colors?.slice(0, 6).map((c) => <Swatch key={c.name} name={c.name} size={10} />)}
          </div>
        </div>
        <span className="text-sm text-zinc-300 whitespace-nowrap">{money(product.price)}</span>
      </div>
    </Link>
  );
}
